import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Microsoft OAuth must redirect to a URL that returns index.html on a cold load.
 * Some static hosts return 404 for deep paths like /financial-modeling-lab; the
 * backend therefore lands on /?excel_status=... and we route client-side here.
 */
export default function ExcelOAuthLandingRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/') return;
    const params = new URLSearchParams(location.search);
    if (!params.has('excel_status')) return;

    navigate({ pathname: '/financial-modeling-lab', search: location.search }, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return null;
}
